import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { CommentEditor } from '../../CommentEditor';
import { NewCommentEditor } from '../../NewCommentEditor';
import type { Comment } from '../../../types';

interface CommentTabProps {
  submissionId: string;
  comments: Comment | null;
  onRefresh: () => void;
}

export default function CommentTab({ submissionId, comments, onRefresh }: CommentTabProps) {
  const [showNewComment, setShowNewComment] = useState(false);

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-xl font-semibold">Historique des commentaires</h3>
        <button
          onClick={() => setShowNewComment(true)}
          className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
        >
          <Plus className="h-4 w-4 mr-2" />
          Nouveau commentaire
        </button>
      </div>

      {showNewComment ? (
        <div className="mb-8">
          <NewCommentEditor 
            submissionId={submissionId}
            onSave={() => {
              setShowNewComment(false);
              onRefresh();
            }}
          />
        </div>
      ) : null}

      {comments ? (
        <CommentEditor
          submissionId={submissionId}
          comments={comments}
          onUpdate={onRefresh}
        />
      ) : (
        <p className="text-gray-500 text-center">Aucun commentaire</p>
      )}
    </div>
  );
}